export default __webpack_public_path__ + "static/media/652.a02aea7c.gif";